/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    SDKEventAuthenticationFailedV1,
    instanceOfSDKEventAuthenticationFailedV1,
    SDKEventAuthenticationFailedV1FromJSON,
    SDKEventAuthenticationFailedV1FromJSONTyped,
    SDKEventAuthenticationFailedV1ToJSON,
} from './SDKEventAuthenticationFailedV1';
import {
    SDKEventAuthenticationSucceededV1,
    instanceOfSDKEventAuthenticationSucceededV1,
    SDKEventAuthenticationSucceededV1FromJSON,
    SDKEventAuthenticationSucceededV1FromJSONTyped,
    SDKEventAuthenticationSucceededV1ToJSON,
} from './SDKEventAuthenticationSucceededV1';
import {
    SDKEventPersonIdentifiedV1,
    instanceOfSDKEventPersonIdentifiedV1,
    SDKEventPersonIdentifiedV1FromJSON,
    SDKEventPersonIdentifiedV1FromJSONTyped,
    SDKEventPersonIdentifiedV1ToJSON,
} from './SDKEventPersonIdentifiedV1';
import {
    SDKEventPersonLoggedOutV1,
    instanceOfSDKEventPersonLoggedOutV1,
    SDKEventPersonLoggedOutV1FromJSON,
    SDKEventPersonLoggedOutV1FromJSONTyped,
    SDKEventPersonLoggedOutV1ToJSON,
} from './SDKEventPersonLoggedOutV1';
import {
    SDKEventSlashIDSDKLoadedV1,
    instanceOfSDKEventSlashIDSDKLoadedV1,
    SDKEventSlashIDSDKLoadedV1FromJSON,
    SDKEventSlashIDSDKLoadedV1FromJSONTyped,
    SDKEventSlashIDSDKLoadedV1ToJSON,
} from './SDKEventSlashIDSDKLoadedV1';
import {
    SDKEventVirtualPageLoadedV1,
    instanceOfSDKEventVirtualPageLoadedV1,
    SDKEventVirtualPageLoadedV1FromJSON,
    SDKEventVirtualPageLoadedV1FromJSONTyped,
    SDKEventVirtualPageLoadedV1ToJSON,
} from './SDKEventVirtualPageLoadedV1';

/**
 * @type EventPostRequestEventData
 * 
 * @export
 */
export type EventPostRequestEventData = { event_name: 'AuthenticationFailed_v1' } & SDKEventAuthenticationFailedV1 | { event_name: 'AuthenticationSucceeded_v1' } & SDKEventAuthenticationSucceededV1 | { event_name: 'PersonIdentified_v1' } & SDKEventPersonIdentifiedV1 | { event_name: 'PersonLoggedOut_v1' } & SDKEventPersonLoggedOutV1 | { event_name: 'SlashIDSDKLoaded_v1' } & SDKEventSlashIDSDKLoadedV1 | { event_name: 'VirtualPageLoaded_v1' } & SDKEventVirtualPageLoadedV1;

export function EventPostRequestEventDataFromJSON(json: any): EventPostRequestEventData {
    return EventPostRequestEventDataFromJSONTyped(json, false);
}

export function EventPostRequestEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPostRequestEventData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['event_name']) {
        case 'AuthenticationFailed_v1':
            return {...SDKEventAuthenticationFailedV1FromJSONTyped(json, true), event_name: 'AuthenticationFailed_v1'};
        case 'AuthenticationSucceeded_v1':
            return {...SDKEventAuthenticationSucceededV1FromJSONTyped(json, true), event_name: 'AuthenticationSucceeded_v1'};
        case 'PersonIdentified_v1':
            return {...SDKEventPersonIdentifiedV1FromJSONTyped(json, true), event_name: 'PersonIdentified_v1'};
        case 'PersonLoggedOut_v1':
            return {...SDKEventPersonLoggedOutV1FromJSONTyped(json, true), event_name: 'PersonLoggedOut_v1'};
        case 'SlashIDSDKLoaded_v1':
            return {...SDKEventSlashIDSDKLoadedV1FromJSONTyped(json, true), event_name: 'SlashIDSDKLoaded_v1'};
        case 'VirtualPageLoaded_v1':
            return {...SDKEventVirtualPageLoadedV1FromJSONTyped(json, true), event_name: 'VirtualPageLoaded_v1'};
        default:
            throw new Error(`No variant of EventPostRequestEventData exists with 'event_name=${json['event_name']}'`);
    }
}

export function EventPostRequestEventDataToJSON(value?: EventPostRequestEventData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['event_name']) {
        case 'AuthenticationFailed_v1':
            return SDKEventAuthenticationFailedV1ToJSON(value);
        case 'AuthenticationSucceeded_v1':
            return SDKEventAuthenticationSucceededV1ToJSON(value);
        case 'PersonIdentified_v1':
            return SDKEventPersonIdentifiedV1ToJSON(value);
        case 'PersonLoggedOut_v1':
            return SDKEventPersonLoggedOutV1ToJSON(value);
        case 'SlashIDSDKLoaded_v1':
            return SDKEventSlashIDSDKLoadedV1ToJSON(value);
        case 'VirtualPageLoaded_v1':
            return SDKEventVirtualPageLoadedV1ToJSON(value);
        default:
            throw new Error(`No variant of EventPostRequestEventData exists with 'event_name=${value['event_name']}'`);
    }

}

